import React, { Fragment } from "react";
import { connect } from "react-redux";
import { ApplicationState, ConnectedReduxProps } from "@reducers/index";
import { Alias } from "@models/alias";
import { deleteRequest, fetchRequest } from "@actions/alias";
import AliasForm from "@components/aliases/Form";
import { createRequest, updateRequest } from "@actions/alias";
import aliasApi from "@api/alias";
import { injectIntl } from "react-intl";

interface PropsFromState {
  loading: boolean;
  data: Alias[];
  errors?: string;
  count: number;
}

interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest;
  deleteRequest: typeof deleteRequest;
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class AliasFormPage extends React.Component<AllProps> {
  state = {
    alias: null,
    alias_id: this.props.match.params.id,
    is_fetched: false
  };

  componentDidMount() {
     
    if (this.state.alias_id) {
      this.fetchItem();
    }
  }

  fetchItem = () => {
    aliasApi
      .getItem({
        params: {
          id: this.state.alias_id
        }
      })
      .then(({ data }) => {
        this.setState({
          alias: data
        });
      })
      .catch(error => console.log(error));
  };

  getContent = () => {
    if (this.state.alias_id && !this.state.alias) {
      return null;
    }

    return (
      <AliasForm
        alias={this.state.alias}
        intl={this.props.intl}
        listUrl={"/aliases"}
        history={this.props.history}
        updateRequest={this.props.updateRequest}
        createRequest={this.props.createRequest}
      />
    );
  };

  render() {
    return <Fragment>{this.getContent()}</Fragment>;
  }
}

const mapStateToProps = ({ aliases }: ApplicationState) => ({
  loading: aliases.loading,
  errors: aliases.errors
});

const mapDispatchToProps = {
  createRequest,
  updateRequest
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(AliasFormPage));
